import { render, staticRenderFns } from "./AdminNotificationDelete.vue?vue&type=template&id=080580dc&scoped=true"
import script from "./AdminNotificationDelete.vue?vue&type=script&lang=js"
export * from "./AdminNotificationDelete.vue?vue&type=script&lang=js"
import style0 from "./AdminNotificationDelete.vue?vue&type=style&index=0&id=080580dc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "080580dc",
  null
  
)

export default component.exports